export const clearForm = (form, defaults = {}) => {
  Object.keys(form).forEach((key) => {
    form[key] = defaults[key] ?? null;
  });
};
